import { Stores } from '../stores';

// exported functions

export function loadEvaluationSettings(stores: Stores): Promise<unknown> {
  const { evaluationSettingsUser } = stores;
  return evaluationSettingsUser.loadData();
}
